import * as React from "react";
import { cn } from "@/lib/utils";

export const Select = React.forwardRef<
  HTMLSelectElement,
  React.SelectHTMLAttributes<HTMLSelectElement>
>(({ className, ...props }, ref) => (
  <select
    ref={ref}
    className={cn(
      "flex h-10 w-full rounded-lg border border-[var(--border-strong)] bg-[var(--surface)] px-3 py-2 text-sm text-[var(--text-primary)] outline-none hover:border-[var(--text-muted)] focus:border-[var(--action)] focus:ring-2 focus:ring-[var(--focus)] disabled:bg-[var(--surface-secondary)] disabled:text-[var(--text-muted)]",
      className,
    )}
    {...props}
  />
));
Select.displayName = "Select";
